import { Grid2} from '@mui/material';
import React from 'react';
import { Result } from '../EmbryoGradingAi.helper';
import { useGradingHistory } from '../GradingHistoryContext';
import ResultListItem from './ResultListItem';


const ResultList: React.FC = () => {

  const { resultListForSelectedPatient , setResultListForSelectedPatient , setSelectedResultFromResultList  } = useGradingHistory();
    
  
  const handleSelect = (result: Result) => {
    const updated = resultListForSelectedPatient.map((p: Result) =>
      p.id === result.id
        ? { ...p, isSelected: true }
        : { ...p, isSelected: false }
    );
    setResultListForSelectedPatient(updated); // List with updated selection
    setSelectedResultFromResultList(result); //Selected Result details
  };

  return (
    <>     
      <Grid2  display="flex" gap={1}  flexDirection="column" size={12} height={'100%'} >
        <Grid2   size={12}  height={'calc(100vh - 355px)'} overflow={'auto'} pr={0.5} >         
          {resultListForSelectedPatient.map((result : Result) => (
            <ResultListItem
              key={result.id}
              result={result}
              onClick={() => handleSelect(result)}
            />
          ))}
        </Grid2>
      </Grid2>

    </>
  );
};
  
export default ResultList;